











































import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ConfiguredImageDto, ProductDto} from "@swagger";
import ImageSelector from "@/components/product-configuration/ImageSelector.vue";
import ImageBatchSelector from "@/components/product-configuration/ImageBatchSelector.vue";

@Component({
  components: {ImageSelectionRow: ImageBatchSelector, ImageSelector}
})
export default class BasicConfigurator extends BasicComponent {

  @Prop(Array) value: ConfiguredImageDto[][]; // Multiple products can be configured at once, an image array for each
  @Prop(Object) product: ProductDto;
  @Prop(Boolean) configurationValid: boolean; // Whether the product may be added to the basket

  addedToBasket: boolean = false;
  
  addToBasket(): void {
    let firstSuccess = true, firstError = true;
    for (let images of this.value) {
      this.addArticleToBasket(this.product.id, images, false, () => {
        if (firstSuccess) {
          this.addedToBasket = true;
          this.$emit("addedToBasket");
          firstSuccess = false;
        }
      }, (error) => {
        if (firstError) {
          this.$emit("error", error);
          firstError = false;
        }
      })
    }
  }

  configureAgain(): void {
    this.addedToBasket = false;
    this.$emit("reset");
  }

  get showBuyButton(): boolean {
    return this.configurationValid;
  }

  get title(): string {
    return this.$t("CONFIGURATOR_TITLE").toString().replace("{name}", this.product.name);
  }

  get buyButtonText(): string {
    if (this.value.length > 1) {
      return this.$t("BUTTON_ADD_MULTIPLE_TO_BASKET").toString().replace("{amount}", this.value.length.toString());
    }
    return this.$t("BUTTON_ADD_TO_BASKET").toString();
  }

}

